import React from "react";
import { useFormContext } from "react-hook-form";
import { NumberControl } from "@tiny/components";
import { useStyles } from "../Value.styles";

interface FrequencyRangeValueProps {
  prefixName: string;
  disabled?: boolean;
}

function FrequencyRangeValue(props: FrequencyRangeValueProps) {
  const { prefixName, disabled } = props;
  const { trigger, watch } = useFormContext();
  const classes = useStyles();

  const value = watch(`${prefixName}.value`);

  const nameFrom = `${prefixName}.value.value[0]`;
  const nameTo = `${prefixName}.value.value[1]`;

  const validateIntNumber = (value?: any) => {
    if (value && typeof value === "number" && value % 1 !== 0) {
      return "Please enter a number without decimal point";
    }
  };

  React.useEffect(() => {
    trigger([nameFrom, nameTo]);
  }, [trigger, nameFrom, nameTo]);

  return (
    <div className={classes.root}>
      <NumberControl
        name={nameFrom}
        className={classes.field}
        placeholder="Times"
        aria-label="Condition times"
        showHelperTextMargin
        required
        disabled={disabled}
        watchValue
        min={1}
        max={100}
        validate={validateIntNumber}
      />
      <NumberControl
        name={nameTo}
        className={classes.field}
        placeholder="Days"
        aria-label="Condition within days"
        showHelperTextMargin
        required
        disabled={disabled}
        watchValue
        min={1}
        max={365}
        validate={validateIntNumber}
      />
    </div>
  );
}

export default FrequencyRangeValue;
